import {axiosBffFetch} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {TicketReadyToUseResultVo} from '../../common/shared/api/nicolas/vo/TicketReadyToUseResultVo.interface';

/**
 * 이용권 준비 상태 조회
 *
 * Origin: pageNicolasApi.getTicketReadyToUse
 * API: GET /api/v1/ticket/ready_to_use
 */
export async function getTicketReadyToUse({
  productId,
  includeSeries,
}: {
  productId: number;
  includeSeries?: boolean;
}): Promise<ApiResultVo & {result: TicketReadyToUseResultVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/ticket/ready_to_use',
    {
      method: 'GET',
      params: {
        product_id: productId,
        ...(includeSeries && {include_series: includeSeries}),
      },
    }
  );
  return response.data;
}
